import { ROLE } from "@/lib/auth/roles";

/**
 * Bảng thi đua hai chiều: Sale và CSKH — nhân viên lẫn trưởng phòng — không
 * xem bảng của khối kỹ thuật (QĐ 0375, CEO chốt 15/10/2026), và khối kỹ thuật
 * — nhân viên lẫn trưởng phòng chụp, trang điểm, hậu kỳ — không xem bảng của
 * Sale, CSKH (QĐ 0472, CEO chốt 2a 27/10/2026). Lễ tân và các vai quản lý chung
 * xem đủ. Các thẻ của trang Xếp Hạng & Huy Chương: bảng xếp hạng, sao khách
 * chấm và Vinh danh do máy chủ cắt sẵn; thẻ Huy chương dựng lưới từ danh bạ
 * nhân sự (`GET /staff`, dùng chung nhiều màn) nên màn phải tự bỏ người phe
 * kia khỏi lưới. Huy chương của họ thì máy chủ đã không gửi (`GET /awards`).
 *
 * Bản sao của `auth.IsBusinessBoardViewer` / `IsTechnicalBoardViewer` /
 * `technicalBoardDepartments` / `businessBoardDepartments` bên Go
 * (`backend/internal/platform/auth/data_visibility.go`). Bài kiểm
 * `board-visibility.test.ts` đọc tệp Go và đỏ khi hai danh sách phòng lệch nhau.
 */
export const TECHNICAL_BOARD_DEPARTMENTS = [
  "makeup",
  "photo",
  "photo_corporate",
  "photo_idphoto",
  "photo_profile",
  "retouch",
] as const;

export const BUSINESS_BOARD_DEPARTMENTS = ["cskh", "sale", "sales"] as const;

type BoardViewer = { role?: string | null; department?: string | null } | null | undefined;

function norm(value: string | null | undefined): string {
  return (value ?? "").trim().toLowerCase();
}

/** Người xem thuộc phòng kinh doanh theo nghĩa QĐ 0375. */
export function isBusinessBoardViewer(user: BoardViewer): boolean {
  if (!user) return false;
  const role = norm(user.role);
  if (role === ROLE.Sale) return true;
  if (role !== ROLE.Staff && role !== ROLE.Manager) return false;
  return (BUSINESS_BOARD_DEPARTMENTS as readonly string[]).includes(norm(user.department));
}

/** Người xem thuộc khối kỹ thuật theo nghĩa QĐ 0472. */
export function isTechnicalBoardViewer(user: BoardViewer): boolean {
  if (!user || isBusinessBoardViewer(user)) return false;
  const role = norm(user.role);
  if (role !== ROLE.Staff && role !== ROLE.Manager) return false;
  return (TECHNICAL_BOARD_DEPARTMENTS as readonly string[]).includes(norm(user.department));
}

/** Người xem có được thấy dòng thi đua của người phòng `department` không. */
export function canSeeDepartmentBoard(user: BoardViewer, department: string | null | undefined): boolean {
  const dept = norm(department);
  if (isBusinessBoardViewer(user)) {
    return !(TECHNICAL_BOARD_DEPARTMENTS as readonly string[]).includes(dept);
  }
  if (isTechnicalBoardViewer(user)) {
    return !(BUSINESS_BOARD_DEPARTMENTS as readonly string[]).includes(dept);
  }
  return true;
}
